const state = {
    inputVerificationResult: {
        isNameEmpty: false,
        hasNameIllegalCharacters: false,
        isCarNoInvalid: false,
        isPhoneInvalid: false,
    },
    smsUid: '',
};

export default state;